import moment from 'moment'
import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import getLocale, {Locale} from 'utils/getLocale'

export default function LocalisedTime({date}: {date: string}) {
  const locale: Locale = getLocale(EnvironmentProvider.useCurrency())

  let format = 'HH:mm'

  if (locale === 'us' || locale === 'uk') {
    format = 'h:mma'
  }

  if (!date) {
    return null
  }

  return <>{moment(date).format(format)}</>
}
